import React from 'react';

/**
 * PageTabs: the tabs across the top of a page (NAMFISA Reports, Messages).
 *
 * Props:
 *   tabs     {Array<{key, label}>}  the tabs, in order
 *   active   {string}               the key of the tab shown
 *   onChange {function}             called with the key of the tab clicked
 */
const PageTabs = ({ tabs, active, onChange }) => (
  <div className="flex gap-1 mb-4 border-b border-gray-200 dark:border-slate-700" role="tablist">
    {tabs.map((t) => (
      <button
        key={t.key}
        type="button"
        role="tab"
        aria-selected={active === t.key}
        onClick={() => onChange(t.key)}
        className={`px-4 py-2 text-sm font-semibold rounded-t-md border-b-2 -mb-px transition-colors ${
          active === t.key
            ? 'border-blue-600 text-blue-700 dark:text-blue-300 bg-blue-50 dark:bg-blue-900/20'
            : 'border-transparent text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-200'
        }`}
      >
        {t.label}
      </button>
    ))}
  </div>
);

export default PageTabs;
